import React, { Component } from 'react';

import ContactMessage from './ContactMessage';

class Contact extends Component {

  state = {
    name: '',
    email: '',
    comment: '',
    fullMessage: ''
  }

  handleNameChange = (e) => {
    this.setState({ name: e.target.value });
  }

  handleEmailChange = (e) => {
    this.setState({ email: e.target.value });
  }

  handleCommentChange = (e) => {
    this.setState({ comment: e.target.value });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ fullMessage: this.state.name + '\n' + this.state.email + '\n' + this.state.comment + ' Your comment has been sent' })
  }

  render() {
    
    return (
      <main>   
        <h2 className="contactPage">Contact Us</h2>
        
        <p className="contactPage">Want to suggest an agency that provides services, request a new feature, or just drop us a note? This is where you can do that. Just fill out the form and submit it.</p>
        
        <p className="contactPage">* Required field</p>
        
        <form name="frmContact" id="frmContact" className="contactPage" onSubmit={this.handleSubmit}>
          <label htmlFor="fullName">Name: </label>
          <input
            type="text" 
            value={this.state.name}
            placeholder="Enter your name"
            name="fullName" 
            id="fullName" 
            onChange={this.handleNameChange}
            required
          />
          
          <label htmlFor="eMail">Email: </label>
          <input 
            type="email" 
            name="eMail"
            value={this.state.email}
            placeholder="Enter your Email address"
            id="eMail"
            onChange={this.handleEmailChange}
            required 
          />
          
          <label htmlFor="comment">Comment: </label>
          <textarea
            rows="2"
            cols="20" 
            name="comment" 
            id="comment"
            onChange={this.handleCommentChange}
          ></textarea>
          
          <input 
            type="submit" 
            value="Submit" 
          />
        </form>

        <ContactMessage cName={this.state.fullMessage} />

      </main>
    );
  }
}

export default Contact;